import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { API_CHANGE_PASSWORD_URL } from "constants/apiUrls";

import useGetApiClient from "./useGetApiClient";
import { OktaError } from "types/oktaError/oktaError";

export type ChangePasswordData = {
  oldPassword: string;
  newPassword: string;
};

function useChangePassword(): UseMutationResult<
  void,
  OktaError,
  ChangePasswordData
> {
  const apiClient = useGetApiClient();

  return useMutation({
    mutationFn: async (passwords: ChangePasswordData) => {
      const response = await apiClient(API_CHANGE_PASSWORD_URL, {
        method: "POST",
        body: JSON.stringify(passwords),
      });

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return Promise.resolve();
      }
    },
  });
}

export default useChangePassword;
